<div class="modal-header user-select-none" [ngClass]="extraCssClasses">
    @if (customIcon && !showBackButton) {
        <div class="modal-title">
            <svg class="mr-1" [ngClass]="customIconClasses" ycnIcon [name]="customIcon"></svg><span>{{header}}</span>
        </div>
    } @else if (showBackButton) {
        <div class="modal-title">
            <a (click)="back.emit()" class="d-flex align-items-center" href="javascript:void(0);">
                <svg class="mr-1" ycnIcon [name]="'icon-back'"></svg><span>{{header}}</span>
            </a>
        </div>
    } @else {
        <div class="modal-title" [textContent]="header"></div>
    }
    <span class="modal-title text-blue" *ngIf="showUnsavedStatus">
        &nbsp;(edited)
    </span>
    <div class="modal-header-actions">
        @if(customHeaderFragment) {
            <ng-container *ngTemplateOutlet="customHeaderFragment"></ng-container>
            <div class="divider-vertical ml-1"></div>
        }
        <div class="modal-header-action" *ngIf="showResetModalHandler">
            <div aria-label="Reset" class="btn btn-modal-header" (click)="resetModalHandler.emit()">
                <svg ycnIcon [name]="'icon-reset'"></svg>
                <span *ngIf="resetModalText" [textContent]="resetModalText"></span>
            </div>
        </div>
        <div *ngIf="showCloseButton" class="modal-header-action">
            <div data-test-id="simple-modal-header-close" aria-label="Close" class="close btn btn-modal-header" (click)="closeModalHandler.emit()">
                <svg ycnIcon [name]="'icon-close'"></svg>
            </div>
        </div>
    </div>
</div>
